<script setup>
import CommsSuppressionManager from '@/@core/components/CommsSuppressionManager.vue'
</script>

<template>
  <VContainer>
    <VRow
      class="mb-4"
      align="center"
    >
      <VCol>
        <h2 class="text-h5">
          Email Suppression List
        </h2>
      </VCol>
    </VRow>
    <CommsSuppressionManager />
  </VContainer>
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
</route>
